"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

require("./sass/cardDefault.scss");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

// Styles props:
// - Paddings
// - Border radius
var CardDefault = function CardDefault(_ref) {
  var _cardClasses;

  var children = _ref.children,
      className = _ref.className,
      sizePadding = _ref.sizePadding,
      elevation = _ref.elevation;
  var cardClasses = (_cardClasses = {}, _defineProperty(_cardClasses, "padding-".concat(sizePadding), sizePadding), _defineProperty(_cardClasses, "card-elevation-".concat(elevation), elevation), _defineProperty(_cardClasses, className, className), _cardClasses);
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _classnames.default)('card', cardClasses),
    tabIndex: "0",
    "data-testid": "cardID"
  }, children);
};

CardDefault.propTypes = {
  children: _propTypes.default.element,
  className: _propTypes.default.string,
  sizePadding: _propTypes.default.oneOf(['small', 'medium', 'large']),
  elevation: _propTypes.default.oneOf(['50', '100'])
};
CardDefault.defaultProps = {
  children: 'Insert a component or HTML tags',
  className: 'default',
  sizePadding: null,
  elevation: '0'
};
var _default = CardDefault;
exports.default = _default;